import { useProductSummaryImage } from '../hooks/useProductSummaryImage';

type CollectionContainerProps = { children: React.ReactNode };

const CollectionContainer = ({ children }: CollectionContainerProps) => {
	const { blockClass, componentId } = useProductSummaryImage();

	return (
		<div
			data-selection={componentId}
			className={`collectionContainer collectionContainer--${blockClass} vtex-product-summary-2-x-collectionContainer vtex-product-summary-2-x-collectionContainer--${blockClass} relative dib w-100`}
		>
			{children}
			<div className="inline-flex justify-end absolute w-100 bottom-0 left-0">
				<div
					className={`item item--${blockClass} vtex-product-summary-2-x-item vtex-product-summary-2-x-item--${blockClass} mh1 pa2 bg-blue white tc`}
				>
					Lançamentos
				</div>
				<div
					className={`item item--${blockClass} vtex-product-summary-2-x-item vtex-product-summary-2-x-item--${blockClass} mh1 pa2 bg-blue white tc`}
				>
					Frete Grátis
				</div>
				<div
					className={`item item--${blockClass} vtex-product-summary-2-x-item vtex-product-summary-2-x-item--${blockClass} mh1 pa2 bg-blue white tc`}
				>
					Black Friday
				</div>
			</div>
		</div>
	);
};

export default CollectionContainer;
